export default {
  'Sample photo': 'Voorbeeld foto',
  Removing: 'Verwijderen',
  Edit: 'Bewerken',
  'Adjust Picture': 'Foto aanpassen',
  Restore: 'Herstellen',
  Eraser: 'Gum',
  Size: 'Formaat',
  Background: 'Achtergrond',
  Custom: 'Aangepast',
  Presets: 'Voorinstellingen',
  'Add Image': 'Afbeelding Toevoegen',
  'Scale to Fit': 'Aanpassen',
  'Full Width': 'Volledige Breedte',
  'Full Height': 'Volledige Hoogte',
  Move: 'Verplaats',
  Undo: 'Ongedaan maken',
  Redo: 'Opnieuw',
  Enlarge: 'Vergroten',
  Reduce: 'Verkleinen',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw Online Achtergrond Verwijderaar',
    desc: "Verwijder de achtergrond van uw foto's 100% automatisch & gratis",
    imgAlt: 'photo background remover',
    submitBtn: 'Achtergrond Verwijderen',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
